export default class DateTime {
    static merge(date, time) {
        const timestamp = window.moment(date);

        time = window.moment(time, 'HH:mm:ss');

        timestamp.set({
            hour: time.get('hour'),
            minute: time.get('minute'),
            second: time.get('second'),
        });

        return timestamp;
    }

    static includesSunday(start) {
        const date = window.moment(start);

        for (let i = 1; i <= 5; i++) {
            if (date.weekday() === 0) {
                return true;
            }

            date.add(1, 'day');
        }

        return false;
    }
}
